'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateSuccess = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('@material-ui/styles');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Typography = require('../Typography');

var _Button = require('../Button');

var _state = require('../../schema/component/state.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-extraneous-dependencies */
var success = _state.properties.success.properties;

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      border: function border(_ref) {
        var _border = _ref.border;
        return _border;
      },
      borderRadius: function borderRadius(_ref2) {
        var _borderRadius = _ref2.borderRadius;
        return _borderRadius;
      },
      margin: '0 auto',
      maxWidth: function maxWidth(_ref3) {
        var width = _ref3.width;
        return width;
      },
      textAlign: 'center',
      '&:before': {
        content: '""',
        background: 'var(--black-cool-050)',
        display: 'block',
        height: function height(_ref4) {
          var divider = _ref4.divider;
          return divider;
        },
        width: '100%'
      },
      '& .state-success--image, .state-success--title, .state-success--message, .state-success--action': {
        marginLeft: 'auto',
        marginRight: 'auto'
      },
      '& .state-success--image': {
        maxWidth: function maxWidth(_ref5) {
          var imageContainerWidth = _ref5.imageContainerWidth;
          return imageContainerWidth;
        }
      },
      '& .state-success--title': {
        marginTop: '0px',
        maxWidth: function maxWidth(_ref6) {
          var titleWidth = _ref6.titleWidth;
          return titleWidth;
        }
      },
      '& .state-success--message': {
        maxWidth: function maxWidth(_ref7) {
          var messageWidth = _ref7.messageWidth;
          return messageWidth;
        }
      },
      '& .state-success--action': {
        maxWidth: function maxWidth(_ref8) {
          var actionWidth = _ref8.actionWidth;
          return actionWidth;
        },
        width: function width(_ref9) {
          var actionWidth = _ref9.actionWidth;
          return actionWidth;
        },
        '& div': {
          textAlign: 'center'
        }
      }
    },
    content: {
      padding: function padding(_ref10) {
        var contentPadding = _ref10.contentPadding;
        return contentPadding;
      }
    },
    image: {
      width: function width(_ref11) {
        var imageWidth = _ref11.imageWidth;
        return imageWidth;
      }
    }
  };
});

var StateSuccess = exports.StateSuccess = function StateSuccess(_ref12) {
  var action = _ref12.action,
      actionCustom = _ref12.actionCustom,
      borders = _ref12.borders,
      className = _ref12.className,
      doms = _ref12.doms,
      id = _ref12.id,
      image = _ref12.image,
      message = _ref12.message,
      padding = _ref12.padding,
      sizes = _ref12.sizes,
      title = _ref12.title,
      type = _ref12.type;

  var properties = success[type] && success[type].properties;
  var classes = useStyles({
    width: sizes && sizes.container || properties.container,
    border: borders && borders.border || properties.border,
    borderRadius: borders && borders.radius || properties.borderRadius,
    divider: sizes && sizes.divider || properties.headerHeight,
    imageContainerWidth: sizes && sizes.image || properties.imageWidth,
    titleWidth: sizes && sizes.title || properties.titleWidth,
    messageWidth: sizes && sizes.message || properties.messageWidth,
    actionWidth: sizes && sizes.action || properties.actionWidth,

    imageWidth: properties.imageWidth,
    contentPadding: padding || properties.padding
  });

  return _react2.default.createElement(
    'div',
    {
      id: id,
      className: classes.container + ' ' + className + ' state-success'
    },
    _react2.default.createElement('img', {
      alt: 'Success State',
      className: classes.image + ' state-success--image',
      src: image || properties.image,
      'data-margin-bottom': properties.imageDivider
    }),
    _react2.default.createElement(
      'div',
      { className: classes.content + ' state-success--content' },
      _react2.default.createElement(
        _Typography.Typography,
        {
          className: 'state-success--title',
          variant: doms && doms.title || properties.titleDOM,
          'data-margin-bottom': properties.titleDivider,
          'data-text-align': 'center'
        },
        title
      ),
      _react2.default.createElement(
        _Typography.Typography,
        {
          className: 'state-success--message',
          variant: doms && doms.message || properties.messageDOM,
          'data-margin-bottom': !actionCustom && !action ? '0px' : properties.messageDivider,
          'data-text-align': 'center'
        },
        message
      ),
      actionCustom,
      action && _react2.default.createElement(
        _Button.Button,
        { className: 'state-success--action', onClick: action.event },
        action.title
      )
    )
  );
};

StateSuccess.defaultProps = {
  action: success.props.action,
  actionCustom: success.props.actionCustom,
  borders: success.props.border,
  className: success.props.className,
  doms: success.props.doms,
  id: success.props.id,
  image: success.props.image,
  message: success.props.message,
  padding: success.props.padding,
  sizes: success.props.sizes,
  title: success.props.title,
  type: success.props.type
};

StateSuccess.propTypes = {
  action: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    event: _propTypes2.default.func
  }),
  actionCustom: _propTypes2.default.node,
  borders: _propTypes2.default.shape({
    border: _propTypes2.default.string,
    radius: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  doms: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    message: _propTypes2.default.string
  }),
  id: _propTypes2.default.string,
  image: _propTypes2.default.string,
  message: _propTypes2.default.string,
  padding: _propTypes2.default.string,
  sizes: _propTypes2.default.shape({
    action: _propTypes2.default.string,
    container: _propTypes2.default.string,
    divider: _propTypes2.default.string,
    image: _propTypes2.default.string,
    message: _propTypes2.default.string,
    title: _propTypes2.default.string
  }),
  title: _propTypes2.default.string,
  type: _propTypes2.default.string
};

exports.default = StateSuccess;